import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { CRUDModes } from '../../../../../interfaces/CRUD';
import DialogCustomTitle from '../../../../../components/DialogCustomTitle/DialogCustomTitle';
import { SponsorSegment } from '../SponsorSegments.Interfaces';
import SponsorSegmentsForm from './SponsorSegmentsForm';

export interface SponsorSegmentsFormProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  mode: CRUDModes;
  onSuccess: () => void;
  values?: SponsorSegment;
  closeFunction?: () => void;
}

const SponsorsSegmentsPopupForm = ({
  open,
  setOpen,
  mode,
  onSuccess,
  values,
  closeFunction,
}: SponsorSegmentsFormProps): JSX.Element => {
  return (
    <Dialog
      maxWidth='xl'
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
          if (closeFunction) closeFunction();
        }
      }}
    >
      <DialogCustomTitle
        onClose={() => {
          setOpen(false);
          if (closeFunction) closeFunction();
        }}
        mode={mode}
        title='segmento de público'
      />
      <DialogContent>
        {open ? (
          <SponsorSegmentsForm
            onSuccess={() => {
              setOpen(false);
              if (closeFunction) closeFunction();
              onSuccess();
            }}
            mode={mode}
            values={values}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default SponsorsSegmentsPopupForm;
